export abstract class ParametricCurve2 {
    x: (t: number) => number;
    y: (t: number) => number;
}

export class SimpleParametricCurve2 implements ParametricCurve2 {
    constructor(public x: (t: number) => number,
                public y: (t: number) => number) {}
}
export class Func implements ParametricCurve2 {
    constructor(private f: (t: number) => number) {}

    x(t: number) { return t; }
    y(t: number) { return this.f(t); }
}
export class Lissajous implements ParametricCurve2 {
    constructor(public a = 1,
                public b = 1,
                public A = 1,
                public B = 1,
                public phaseOffset = 0) {}
    x(t: number) {
        return this.A * Math.sin(this.a * t + this.phaseOffset);
    }
    y(t: number) {
        return this.B * Math.sin(this.b * t);
    }
}




// WEBPACK FOOTER //
// ./src/code/Math/ParametricCurve.ts